import React from "react";
import useChangeTitle from "../Hooks/useChangeTitle";
import Section from "../Components/Section.jsx";
import Button from "../Components/Button.jsx";
import { homeData } from "../Data/Data.js";
import MainCarousel from "../Components/MainCarousel.jsx";
import { Link } from "react-router-dom";
import WorkCarousel from '../Components/WorkCarousel/WorkCarousel.jsx';

export default function Home() {
  useChangeTitle("Home");

  return (
    <>
      <MainCarousel />

      <Section
        title={homeData.aboutUs.title}
        desc={homeData.aboutUs.desc}
        className="items-center bg-white" 
      />
      
      <Section
        title={homeData.ourServices.title}
        desc={homeData.ourServices.desc}
        className="items-center bg-gray-50" 
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-4 py-8">
          {homeData.servicesCard.map(card => (
            <div key={card.id} className="bg-white text-center rounded-xl shadow-lg transform transition-transform duration-300 ease-in-out hover:scale-105 overflow-hidden">
              <img src={card.imageUrl} alt={card.title} className="w-full h-52 object-cover" />
              <div className="p-8">
                <h2 className="text-xl font-semibold mb-4">{card.title}</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">{card.description}</p>
                <Link to={card.link}>
                  <Button>
                    Read more
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section
        title={homeData.ourWork.title}
        desc={homeData.ourWork.desc}
        className="items-center bg-white"
      >
        <WorkCarousel />
        
        <div className="text-center mt-8">
          <Link to="/projects">
            <Button outline={true}>See all work</Button>
          </Link>
        </div>
      </Section>

    </>
  );
}
